<template>
  <div class="ingredients__container container-fluid">
    <div class="add-ingredients__header row align-middle">
            <div class="col-3 text-center"><h3>Ingredients</h3></div>
            <div class="col-2 text-center"><h3>Specifications</h3></div>
            <div class="col-2 text-center"><h3>Preparation</h3></div>
            <div class="col-1 text-center"><h3>Amount</h3></div>
            <div class="col-2 text-center"><h3>Units</h3></div>
            <div class="col-1 text-center"><h3>Grams</h3></div>
            <div class="col-1 text-center"><h3>Remove</h3></div>
    </div>
    <div class="add-ingredients__body">
      <draggable v-model="savedIngredients">
        <div 
        v-for='(item, index) in savedIngredients'
        :key='item.id'
        :data-id="index"
        draggable
        @start="startDrag(evt)" 
        @end="onDrop(evt)">
          <div class="drag-el">
              <div class='col-1'>
                <p>
                  <i class="fas fa-arrows-alt"></i>
                </p>
              </div>
              <div class='col-2'>
                <p>
                  <base-input
                    ref="specbox"
                    name="ingredientName"
                    type="text"
                    placeholder="Name"
                    v-if="item.subRecipeId == undefined || item.subRecipeId == '00000000-0000-0000-0000-000000000000'"
                    v-on:input="updateIngredientAmount(item)"
                    v-model="item.ingredientName">
                  </base-input>
                  <span v-if="item.subRecipeId != undefined && item.subRecipeId != '00000000-0000-0000-0000-000000000000'" v-html="item.ingredientName"></span>
                </p>
              </div>
              <div class='col-2'>
                <base-input
                  ref="specbox"
                  name="itemCode"
                  type="text"
                  placeholder="Item Code"
                  v-on:input="updateIngredientAmount(item)"
                  v-model="item.itemCode">
                </base-input>
              </div>
              <div class='col-2'>
                <base-input
                  ref="specbox"
                  name="spec"
                  type="text"
                  placeholder="Specifications"
                  v-on:input="updateIngredientAmount(item)"
                  v-model="item.spec">
                </base-input>
              </div>
              <div class='col-2'>
                <base-input
                  name="prep"
                  type="text"
                  placeholder="Preparation"
                  v-on:input="updateIngredientAmount(item)"
                  v-model="item.prep">
                </base-input>
              </div>
              <div class='col-1'>
                <base-input
                  name="volume"
                  type="text"
                  placeholder="Amount"
                  v-on:input="updateIngredientAmount(item)"
                  v-model="item.volume">
                </base-input>
              </div>
              <div class='col-2'>

                <div v-show="unitsLoading" class="loading">
                  <loading-panel></loading-panel>
                </div>

                <base-input
                  name="units"
                  v-show="!unitsLoading"
                  >
                <el-select
                  v-model="item.unit"
                  filterable
                  v-on:input="updateIngredientAmount(item)"
                  placeholder="Select Unit"
                >
                  <el-option v-for="(option) in possibleUnits"
                    :key="option.id"
                    :label="option.name"
                    :value="option.id">
                  </el-option>
                </el-select>
              </base-input>

              </div>
              <div class='col-1'>
                <base-input
                  name="grams"
                  type="text"
                  placeholder="Grams"
                  v-on:input="updateIngredientAmount(item)"
                  v-model="item.grams">
                </base-input>
              </div>
              <div class='col-1 text-center'>
                <span
                  v-on:click="removeRow(item)"
                  class="shortcut-media avatar rounded-circle bg-gradient-red">
                  <i class="fas fa-minus"></i>
                </span>
              </div>

          </div>
        </div>
      </draggable>
    </div>
    <div class="form-row">
      <b-col sm="12" md="6">
        <label class="form-control-label mt-5">Add New Ingredient</label>
        <SearchIngredients
          @newIngredient="addNewIngredient"
        />
      </b-col>
      <b-col sm="12" md="6">
        <label class="form-control-label mt-5">Add New SubRecipe</label>
        <SearchRecipes
          @newSubRecipe="addNewSubRecipe"
        />
      </b-col>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import SearchIngredients from '../Components/SearchIngredients.vue';
import SearchRecipes from '../Components/SearchRecipes.vue';
import BaseInput from '../../components/Inputs/BaseInput.vue';
import draggable from 'vuedraggable';
import LoadingPanel from '@/components/LoadingPanel.vue';

export default {
  name: "IngredientTable",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    SearchIngredients,
    SearchRecipes,
    BaseInput,
    draggable,
    LoadingPanel
  },
  props: {
    ingredients: Array
  },
  data () {
    return {
      searchQuery: ""
    }
  },
  computed: {
    savedIngredients: {
      get: function() {
        return this.$store.state.ingredients.saved
      },
      set: function(value) {
        this.$store.dispatch('ingredients/setSavedIngredients', value)
      },
    },
    possibleUnits() {
      return Object.values(this.$store.state.units.selectList)
    },
    unitsLoading() {
      return this.$store.state.units.loading
    },
    filteredResults() {
      return this.possibleUnits.filter(units => units.name.includes(this.searchQuery));
    }
  },
  created() {
    this.savedIngredients = Array
    this.setIngredients()
    const { dispatch } = this.$store;
    dispatch('units/getSelectList');
  },
  methods: {
    setResult(result) {
      this.searchQuery = result.name;
      this.searchModalVisible = false;
      this.unit = result;
      this.setIngredients();
    },
    setIngredients() {
      const { dispatch } = this.$store;
      dispatch("ingredients/setSavedIngredients", this.savedIngredients);
    },    
    updateIngredientAmount(ingredient) {
      const item = this.savedIngredients.find(item => item.rid == ingredient.rid)
      item.name = ingredient.name
      item.itemCode = ingredient.itemCode
      item.spec = ingredient.spec
      item.prep = ingredient.prep
      item.volume = ingredient.volume
      item.unit = ingredient.unit
      item.grams = ingredient.grams
      this.setIngredients()
    },
    addUnit(event,ingredient) {
      if (event.keyCode === 13) {
        event.preventDefault();

        const item = this.savedIngredients.find(item => item.rid == ingredient.rid)
        item.itemCode = ingredient.itemCode
        item.spec = ingredient.spec
        item.prep = ingredient.prep
        item.volume = ingredient.volume
        item.unit = { "id": "", "description": this.searchQuery }
        item.grams = ingredient.grams
        this.setIngredients()
      }
    },
    removeRow(item){
      this.savedIngredients.splice(this.savedIngredients.findIndex(function(i){
          return i.id === item.id;
      }), 1);
      this.setIngredients()
    },
    startDrag: (evt) => {
    },
    onDrop (evt) {
    },
    addNewIngredient(ingredient) {
      var ri = { "id":ingredient.id, "ingredientName": ingredient.description, "ingredientId": ingredient.id, "ingredient": ingredient, "position": this.savedIngredients.length + 1, "sortOrder": ingredient.position };
      ri.rid = Date.now().toString(36) + Math.random().toString(36).substring(2);
      if ( !ri.possibleUnits ) {
        ri.possibleUnits = this.possibleUnits
      }
      this.savedIngredients.push(ri)
      this.setIngredients()
    },
    addNewSubRecipe(recipe) {
      var ri = { "id":recipe.id, "ingredientName": recipe.name, "subRecipeId": recipe.id, "subRecipe": recipe, "position": this.savedIngredients.length + 1, "sortOrder": recipe.position };
      ri.rid = Date.now().toString(36) + Math.random().toString(36).substring(2);

      if ( !ri.possibleUnits ) {
        ri.possibleUnits = this.possibleUnits
      }
      this.savedIngredients.push(ri)
      this.setIngredients()
    },
    setOtherPosition(start, end){
      const item = this.savedIngredients.splice(this.savedIngredients.findIndex(function(i){
          return i.position === end;
      }), 1);
      item.position = start
      item.sortOrder = start
      this.savedIngredients.push(item[0])
      this.setIngredients()
    }
  },
  watch: {

  }
}
</script>
<style scoped>
.search-ingredients{
  margin-bottom: 40px;
}
</style>